<template>
    <div id="mail-templates" class="page-layout__inner">
        <div :class="'page-layout__filter' + (menuSettings.visible ? '' : ' w-auto')">
            <section :class="'section  section--shadow-0  section--p-0' + (menuSettings.visible ? ' h-100' : '')">
                <button @click="menuSettings.visible = true" :title="getTranslation('templates')" :class="'section__filter-btn' + (menuSettings.visible ? ' section__filter-btn--hidden' : '')">
                    <svg class="section__filter-icon">
                        <use xlink:href="#icon__layers"></use>
                    </svg>
                </button>
                <div :class="'section__filter' + (menuSettings.visible ? '' : ' section__filter--hidden')">
                    <div class="section__header">
                        <h3 class="section__title">
                            <svg class="section__filter-icon">
                                <use xlink:href="#icon__layers"></use>
                            </svg>
                            {{ getTranslation('templates') }}
                        </h3>

                        <div class="section__controls">
                            <div class="section__controls-group">
                                <a @click="menuSettings.visible = false" class="btn  btn--xs  btn--control  js-filterHider" href="javascript:void(0)">{{ getTranslation('hide') }}</a>
                                <a class="btn  btn--xs  btn--control" href="javascript:void(0)" @click="fetchTemplates">{{ getTranslation('refresh') }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="section__body">
                        <div class="list-group">
                            <a v-for="item in templates" v-bind:key="item.id" @click="selectTemplate(item)" href="javascript:void(0)" class="list-group-item list-group-item-action" :class="{ 'active': item.id === template.id }">
                                {{ item.title }}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="page-layout__content">
            <div v-if="!template.id" class="d-flex w-100 h-100 justify-content-center align-items-center">
                <p class="font-weight-bold color-grey-darker">{{ getTranslation('selectTemplate') }}</p>
            </div>
            <form v-else @submit.prevent="saveTemplate">
                <div class="form__group">
                    <label class="form__label  form__label--block">{{ getTranslation('mailTitle') }}</label>
                    <input v-model="template.title" @input="this.changed = true" class="field field--bg-grey js-borderOnFocus field--md" type="text" :placeholder="getTranslation('mailTitle')">
                </div>
                <div class="form__group">
                    <label class="form__label  form__label--block">{{ getTranslation('mailParameters') }}</label>
                    <span v-if="template.params.length < 1" class="empty" >{{ getTranslation('notAddedYet') }}</span>
                    <button v-for="(param, key) in template.params" v-bind:key="key" @click="insertParam(param)" type="button" class="btn btn--main-outline">{{ param }}</button>
                </div>
                <div class="form__group">
                    <label class="form__label  form__label--block">{{ getTranslation('mailContent') }}</label>
                    <ckeditor
                            ref="mailContent"
                            :editor="editorOptions.editor"
                            v-model="template.body"
                            :config="editorOptions.editorConfig"
                            @blur="saveEditorState"
                            @focus="saveEditorState"
                    />
                </div>
                <div class="form__group">
                    <button type="submit" class="btn btn--main">{{ getTranslation('save') }}</button>
                    <button @click="unselectTemplate" type="button" class="btn btn--main-outline">{{ getTranslation('cancel') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

    import ckeditorMixin from "@/components/mixins/Ckeditor";

    export default {
        name: "Index",
      mixins:[ckeditorMixin],
        data() {
            return {
                templates: [],
                template: {
                    id: '',
                    title: '',
                    body: '',
                    params: '',
                    module: '',
                    type: ''
                },
                editorModel: null,
                menuSettings: {
                    visible: true
                },
                changed: false,
                init: false
            }
        },
        watch: {
            'template.body'() {
                if ( !this.init ) this.changed = true;
                else this.init = false;
            }
        },
        created() {

            this.setHeadings( {
                title: this.getTranslation( 'mailTemplates' )
            } );

            this.fetchTemplates();

        },
        methods: {
            fetchTemplates() {
                return this.axios.get( this.$config.urls.email.fetchTemplates.url )
                           .then( response => {
                               this.templates = response.data.data;
                           } ).catch(()=>{});
            },
            saveTemplate() {
                return this.axios.put( this.$config.urls.email.fetchTemplates.url, this.template )
                           .then( response => {

                               this.templates = this.templates.map( template => {
                                   if ( response.data.data.id === template.id )
                                       template = { ...response.data.data };

                                   return template;
                               } );

                               if ( response.data.data.params )
                                   response.data.data.params = response.data.data.params.split( '{' ).map( el => '{' + el.split( '}' )[0] + '}' ).slice( 1 );
                               else
                                   response.data.data.params = [];

                               this.template = response.data.data;
                               this.snotifySuccess( 'saveSuccessMsg' );
                               this.changed = false;
                           } ).catch(()=>{});
            },
            selectTemplate( template ) {
                if ( !this.template.id || !this.changed ) {
                    let temp = { ...template };

                    if ( temp.params )
                        temp.params = temp.params.split( '{' ).map( el => '{' + el.split( '}' )[0] + '}' ).slice( 1 );
                    else
                        temp.params = [];

                    this.template = { ...temp };
                    this.editorOptions.model = null;
                    this.init = true;
                    this.changed = false;
                }
                else {
                    this.$snotify.confirm( this.getTranslation( 'unsavedTemplateMsg' ), {
                        showProgressBar: false,
                        closeOnClick: false,
                        backdrop: 0.5,
                        buttons: [
                            {
                                text: this.getTranslation( 'save' ), action: ( toast ) => {
                                    this.saveTemplate().then( () => {
                                        let temp = { ...template };

                                        if ( temp.params )
                                            temp.params = temp.params.split( '{' ).map( el => '{' + el.split( '}' )[0] + '}' ).slice( 1 );
                                        else
                                            temp.params = [];

                                        this.template = { ...temp };
                                        this.editorOptions.model = null;
                                        this.$snotify.remove( toast.id );
                                        this.init = true;
                                    } ).catch(()=>{});
                                }, bold: true
                            },
                            {
                                text: this.getTranslation( 'doNotSave' ), action: ( toast ) => {
                                    this.$snotify.remove( toast.id );
                                    let temp = { ...template };

                                    if ( temp.params )
                                        temp.params = temp.params.split( '{' ).map( el => '{' + el.split( '}' )[0] + '}' ).slice( 1 );
                                    else
                                        temp.params = [];

                                    this.template = { ...temp };
                                    this.editorOptions.model = null;
                                    this.init = true;
                                    this.changed = false;
                                }
                            },
                            { text: this.getTranslation( 'cancel' ), action: ( toast ) => this.$snotify.remove( toast.id ) }
                        ]
                    } );
                }
            },
            unselectTemplate() {
                this.template.id = '';
            },
            saveEditorState( e, i ) {
                this.editorOptions.model = i.model;
            },
            insertParam( param ) {
                if ( this.editorOptions.model ) this.editorOptions.model.change( writer => {
                    writer.insertText( param, this.editorOptions.model.document.selection.getFirstPosition() );
                } );
                else this.template.body = param + this.template.body;
            }
        }
    }
</script>

<style scoped>
    #mail-templates .ck-content {
        min-height: 300px;
    }
</style>
